export const LOAD = 'GarmentTypes/LOAD'
export const LOAD_SUCCESS = 'GarmentTypes/LOAD_SUCCESS'
export const LOAD_FAILURE = 'GarmentTypes/LOAD_FAILURE'
